export const platformTerms =
    'In its current release, the iAMP-Hydro Platform does not impose any additional terms in comparison to the platform terms of use.';
